import { useEffect } from "react";
import { t } from "i18next";
import { useForm } from "react-hook-form";
import { Box, Button, Typography } from "@mui/material";
import {
  useCreateUpdateSubdivisionMutation,
  useGetSubdivisionListQuery,
  useLazyGetSubdivisionByIdQuery,
} from "../../../middleware/usersApi";
import { formFields } from "./columns";
import FormItem from "../../components/FormItem";
import { basicInformationConfig } from "./form-config";
import SimpleTreeView from "./Tree/SubdivisionTree";
import { useAction } from "../../../hooks/actions";
import "./styles.css";

const EditSubdivision = () => {
  const { setIsErrorSubmit, setIsSuccessSubmit } = useAction();
  const { data: subdivisionList = [], refetch: refetchSubdivisionList } = useGetSubdivisionListQuery({
    loadHierarchy: true,
    hasParents: false,
  });
  const [createUpdateSubdivision, { isLoading, error }] = useCreateUpdateSubdivisionMutation();
  const [getSubdivisionById] = useLazyGetSubdivisionByIdQuery();

  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  const isGroup = watch(formFields.isGroup);
  const isWarningValidation = !!Object.keys(errors).length;

  const formConfig = basicInformationConfig(isGroup).filter((item) => item.isVisible);

  const handleClickOnListItem = (id) => {
    getSubdivisionById(id).then((response) => {
      reset({
        id: response.data.id,
        name: response.data.name,
        isGroup: response.data.isGroup,
        serviceAreas: response.data.addresses?.map((item) => ({ address: item })) || [],
        subdivisionIds: response.data.subdivisionIds,
      });
    });
  };

  const onSubmit = (data) => {
    const preparedData = {
      ...data,
      addresses: data.serviceAreas.map(({ address }) => ({ ...address })),
    };
    createUpdateSubdivision(preparedData).then((response) => {
      if (!response.error) {
        refetchSubdivisionList({});
      }
    });
  };

  useEffect(() => {
    refetchSubdivisionList();
  }, []);

  // useEffect(() => {
  //   setIsErrorSubmit(error);
  //
  // }, [error]);

  // useEffect(() => {
  //   setIsSuccessSubmit(isSuccess);
  //
  // }, [isSuccess]);

  return (
    <Box>
      <Box className="template_page-header">
        <Typography className="title-page">Редактировать подразделение</Typography>
        <Box className="template_page-header-buttons">
          <Button
            form="edit-subdivision-form"
            className="btn btn-primary-fill"
            type="submit"
            disabled={isWarningValidation || isLoading}
          >
            {t("button:save")}
          </Button>
        </Box>
      </Box>
      <Box className="subdivision__content-container">
        {subdivisionList.length && (
          <SimpleTreeView data={subdivisionList} handleClickOnListItem={handleClickOnListItem} />
        )}
        <Box className="subdivision__form-container">
          <Box className="subdivision__form-title">Редактировать подразделение</Box>
          <form id="edit-subdivision-form" className="subdivision__form" onSubmit={handleSubmit(onSubmit)}>
            {formConfig.map(({ name, label, input, type, CustomFormItem, ...rest }) =>
              CustomFormItem ? (
                <CustomFormItem key={name} control={control} errors={errors} name={name} {...rest} />
              ) : (
                <FormItem
                  key={name}
                  control={control}
                  errors={errors}
                  name={name}
                  label={label}
                  input={input}
                  type={type}
                  {...rest}
                />
              )
            )}
          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default EditSubdivision;
